// extracted by mini-css-extract-plugin
export default {"stickyArticleHeader":"G_bN","stickyArticleHeaderContainer":"G_bP","stickyArticleHeaderButton":"G_bQ","text_left":"G_bR","progressContainer":"G_bS","progressBar":"G_bT"};